import RestClient from './RestClient';
import { EquipmentCatalogArticle } from '../../models';

class EquipmentCatalogArticles extends RestClient {
    constructor() {
        super({
            model: EquipmentCatalogArticle,
            entryPoint: 'equipment_catalog_article',
            resource: 'equipment_catalog_article',
            resources: 'equipment_catalog_articles',
            id_field: 'id',
            sortBy: 'name'
        });
    }
}

const EquipmentCatalogArticlesApi = new EquipmentCatalogArticles();

export default EquipmentCatalogArticlesApi;
